import { debugRunner } from './lib/debug-runner';

export default debugRunner;
